module.exports = "/_next/static/images/p_react-ab31c45f969e14cc52a6e7ed69de3240.png";